// Kren Reviews — cleared of fabricated content (30/08/2026)
// Real reviews to be added when collected from verified customers.
window.__KREN_REVIEWS__ = [];
